export default {

    state: {
      cda: null,
      recoverFilter: false,
      filtro: {},
      configTable: {},
      resultado: [],
    },
  
    mutations: {
        setCDA(state, payload) {
          state.cda = payload;
        },
        setRecoverFilterCDA(state, payload) {
          state.recoverFilter = payload;
        },
        setConfigTableCDA(state, payload) {
          state.configTable = payload;
        },
        setFiltroCDA(state, payload) {
          state.filtro = payload;
        },
        setResultadoCDA(state, payload) {
          state.resultado = payload;
        }

    },
  
    getters: {
      getCDA(state) {
        return state.cda;
      },
      getRecoverFilterCDA(state) {
        return state.recoverFilter;
      },
      getConfigTableCDA(state) {
        return state.configTable;
      },
      getFiltroCDA(state) {
        return state.filtro;
      },
      getResultadoCDA(state) {
        return state.resultado;
      },
    },

    actions: {
        setCDA({commit}, cda){
          commit('setCDA', cda);
        },

        setRecoverFilterCDA({commit}, payload){
          commit('setRecoverFilterCDA', payload);
        },

        setConfigTableCDA({commit}, payload){
          commit('setConfigTableCDA', payload);
        },

        setFiltroCDA({commit}, payload){
          commit('setFiltroCDA', payload);
        },

        setResultadoCDA({commit}, payload){
          commit('setResultadoCDA', payload);
        },
    },
    
  }